module.exports = __webpack_public_path__ + "static/scale-model-of-ocreia-in-garden-grove-california-6c2d61b0f121e7db5a0bcb9f9d76f222.png";